import { useState } from "react";

import MaterialTabbar from "./MaterialTabbar";
import Active from "./Active";
import Archive from "./Archive";

const Materials = () => {
  const [tab, setTab] = useState("Active");
  const [showAddMaterial, setShowAddMaterial] = useState(false);
  const handleTabChange = (tab) => {
    setTab(tab);
  };
  const handleAddMaterial = () => {
    setShowAddMaterial(true);
  };
  return (
    <div>
      <MaterialTabbar onTabChange={handleTabChange} />
      {tab === "Active" ? <Active /> : <Archive />}
    </div>
  );
};

export default Materials;
